var map = {
	"./ActivityTemplateDigital.vue": 5884,
	"./ActivityTemplatePractical.vue": 9596,
	"./BagOfWordsPractical.vue": 7183,
	"./EmbodiedSentenceGeneration.vue": 2370,
	"./TextCleaning.vue": 6014,
	"./TextGeneration.vue": 2628
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7851;